module.exports = __webpack_public_path__ + "static/osiris_02-73c14bd4ab870d42f840427f362fb476.jpg";